module.exports = __webpack_public_path__ + "static/11-3-dbac1d86516e48764bfc1078b8a800e1.jpg";